// D35 bloco H (docs/ticket-detail-2027/02-design/d35-v20.md): a 5ª janela do lab — painel lateral do cliente ("i"), do ticket (olho do
// evento) e do pedido (olho do evento e "Pedido N"). O painel é a 3ª coluna do flex da .row; a fila encolhe para o trilho de iniciais.
//
// - Movimento (§2.4): as larguras de início e de fim são fixadas em px INLINE (quadro-chave), e o CSS (_olho.scss) as anima em 884 ms
//   --ease. O conteúdo da fila e do painel tem largura final fixa durante o movimento (revela, não espreme). O contexto fica parado.
//   Abaixo de 720 de .tk-tela o painel é uma camada (transform, 416 ms) e nada é posto inline.
// - Abrir, trocar (outro gatilho: sem movimento), fechar (mesmo gatilho, ×, ">" do trilho, película, troca do detalhe, Esc pelo SaidaDetalhe).
// - Película e foco preso só no cliente (dialog modal: inert em fila, detalhe, menu e topo). Ticket/pedido: complementary, sem inert fora.
// - Conteúdo por fetch próprio, sem o Loader (sem o véu da v18): esqueleto, 15 s, sequência (resposta velha descartada), erro com
//   "Tentar de novo", 419/redirect/não-JSON = sessão expirada.
// - Texto do painel: o comentário interno e o e-mail vão ESCAPADOS (&<>"' em entidades, quebra de linha em <br>) no hidden do form, no
//   submit, antes do .form-ajax delegado do jQuery (o servidor e a lista legados renderizam o comentário como HTML, comment-item:107).
// - Pusher (§5.4): tk:ticket-evento do FilaAbas → recarrega o painel do ticket em 1,5 s; com texto ou foco dentro, só a faixa "Este ticket
//   mudou. Atualizar".
// - Exporta window.tkOlho = { aberto(), fechar(origem) → Promise<boolean> } (o Esc de 4 degraus mora no SaidaDetalhe, §2.6).

const SaidaDetalhe = require('./SaidaDetalhe');
const NavScroll = require('./NavScroll');

const TEMPO_MS = 15000;
const MOV_MS = 884;
const FOLGA_MS = 150;
const LOTE_MS = 1500;
const UNICO_MS = 416;
// DD-04 (docs/oportunidades-2027/02-design/dd04-mapa.md M2/M4/M8): seletores, ids e classes criadas pelo init(opts). Sem opts = Tickets.
// Chaves sem ponto (olhoHead, olhoTit...) são NOME de classe: o seletor é '.' + chave (a mesma string que o literal tinha).
const PADRAO = {
    tela: '.tk-tela', detalhe: '.open-ticket-detail', ctx: '.tk-ctx', corpo: '.tk-detalhe-corpo', lista: '#tk-fila-itens', item: '.tk-item',
    abrir: '.tk-item-abrir', nome: '.tk-nome-txt', assunto: '.tk-assunto', aberto: '.open-ticket-detail .tk-faixa[data-ticket]', gatilho: '.tk-head-olho',
    head: '.open-ticket-detail .tk-head', nums: '.open-ticket-detail .tk-head .tk-nums', headUser: '.open-ticket-detail .tk-head[data-user]',
    buscaCampo: '#tk-fila .tk-busca input[type="search"]', filaId: 'tk-fila', olhoId: 'tk-olho', olhoIn: '.tk-olho-in', trilhoId: 'tk-trilho',
    trilhoLista: '.tk-trilho-lista', trilhoAbrir: '.tk-trilho-abrir', trilhoItem: '.tk-trilho-item', veu: ':scope > .tk-olho-veu', veuTopo: 'tk-olho-veu-topo',
    linhaGrade: ':scope > .row', olhoTitId: 'tk-olho-tit', olhoTit: 'tk-olho-tit', olhoHead: 'tk-olho-head', olhoCorpo: 'tk-olho-corpo',
    olhoX: 'tk-olho-x', olhoL1: 'tk-olho-linha', olhoEsq: 'tk-olho-esq', olhoEsqLinha: 'tk-olho-ficha-linha', olhoEsqTxt: 'tk-olho-ficha-txt',
    olhoEsqIco: 'tk-olho-ficha-ico', olhoMsg: 'tk-olho-msg', olhoAcao: 'tk-olho-acao', olhoTentar: 'tk-olho-tentar', olhoMudou: 'tk-olho-mudou',
    cliTentar: '.tk-cli-tentar', olhoForm: 'form[data-tk-olho-escapar]', olhoTexto: 'textarea.tk-olho-texto', olhoAnexoNome: '.tk-olho-anexo-nome',
    olhoDocs: 'details.tk-olho-docs', olhoPe: '.tk-olho-pe input[type="file"]', olhoSel: 'select.tk-olho-sel[name="ticket_type_id"]',
};
let S = PADRAO;

const PainelOlho = function () {

    let tela, fila, olho, olhoIn, trilho, trilhoLista, veu, veuTopo;
    let T = {};
    const st = { tipo: null, id: null, url: '', gatilho: null, fase: null, seq: 0, ctrl: null, fim: null, rolagem: null, lote: null, inertes: [] };

    // no cliente, o erro/sessão/tentar são os do D24 (data-textos do "i": tk_cli_erro, tk_cli_sessao, tk_cli_tentar)
    const CLI = { olho_erro: 'erro', olho_sessao: 'sessao', olho_tentar: 'tentar' };
    const t = (k) => (st.tipo === 'cliente' && st.cliTxt && CLI[k] && st.cliTxt[CLI[k]]) || T[k] || k;
    const B = (el) => el.getBoundingClientRect();
    const reduz = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    const larguraTela = () => B(tela).width;
    const regime = () => { const w = larguraTela(); return w < 720 ? 'unico' : (w < 1297 ? 'gaveta' : '3col'); };
    const larguraPainel = () => { const w = larguraTela(); return w < 720 ? w : (w < 1297 ? 320 : Math.max(320, 0.24 * w)); };   // §4
    const larguraFila = () => Math.max(360, 0.24 * larguraTela());                                                                  // _detail.scss:122
    const ctxEl = () => document.querySelector(S.detalhe + ' ' + S.ctx);
    const aberto = () => !!st.tipo;
    const mesmo = (g) => !!g && g.dataset.olho === st.tipo && String(g.dataset.id || '') === String(st.id || '');

    // ---------- realce da origem (§2.8) ----------
    const realcar = (liga) => {
        document.querySelectorAll(S.tela + ' [data-olho][aria-expanded="true"], ' + S.tela + ' [data-olho][aria-pressed="true"]').forEach(g => {
            if (g.hasAttribute('aria-expanded')) g.setAttribute('aria-expanded', 'false');
            if (g.hasAttribute('aria-pressed')) g.setAttribute('aria-pressed', 'false');
            g.removeAttribute('aria-current');
        });
        if (!liga || !st.tipo) return;
        document.querySelectorAll(S.tela + ' [data-olho="' + st.tipo + '"]').forEach(g => {
            if (String(g.dataset.id || '') !== String(st.id || '')) return;
            if (g.hasAttribute('aria-expanded')) g.setAttribute('aria-expanded', 'true');
            if (g.hasAttribute('aria-pressed')) g.setAttribute('aria-pressed', 'true');
            if (g.classList.contains('tk-ped-num')) g.setAttribute('aria-current', 'true');
        });
    };

    // ---------- trilho (§2.3, §5.1) ----------
    const iniciais = (nome) => {
        const p = String(nome || '').trim().split(/\s+/).filter(Boolean);
        return ((p[0] || '?').charAt(0) + (p.length > 1 ? p[p.length - 1].charAt(0) : '')).toUpperCase();
    };
    const refazerTrilho = () => {
        if (!trilhoLista || !aberto()) return;
        const itens = Array.from(document.querySelectorAll(S.lista + ' ' + S.item));
        const frag = document.createDocumentFragment();
        let grupo = null, dono = null;
        itens.forEach(it => {
            const d = it.dataset.dono || '';
            if (!grupo || d !== dono) { grupo = document.createElement('div'); grupo.className = 'tk-trilho-grupo'; frag.appendChild(grupo); dono = d; }
            const id = it.id.replace('opportunity_', '');
            const nome = (it.querySelector(S.nome) || {}).textContent || '';
            const assunto = (it.querySelector(S.assunto) || {}).textContent || '';
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'tk-trilho-item';
            b.dataset.ticket = id;
            b.textContent = iniciais(nome);
            b.setAttribute('aria-label', nome.trim());
            b.title = nome.trim() + ' · #' + id + (assunto.trim() ? ' · ' + assunto.trim() : '');
            if (it.getAttribute('aria-current') === 'true') b.setAttribute('aria-current', 'true');
            grupo.appendChild(b);
        });
        trilhoLista.replaceChildren(frag);
    };

    // ---------- conteúdo (§3) ----------
    const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt !== undefined) e.textContent = txt; return e; };
    const xBtn = () => {
        const x = el('button', S.olhoX); x.type = 'button';
        x.setAttribute('aria-label', t('olho_fechar')); x.title = t('olho_fechar');
        const i = el('i', 'ai ai-x'); i.setAttribute('aria-hidden', 'true'); x.appendChild(i);
        return x;
    };
    const casca = (corpo) => {
        const h = el('header', S.olhoHead);
        const l = el('div', S.olhoL1);
        const tit = el('h2', S.olhoTit); tit.id = S.olhoTitId; tit.tabIndex = -1;
        l.append(tit, xBtn());
        h.appendChild(l);
        const c = el('div', S.olhoCorpo);
        c.appendChild(corpo);
        return [h, c];
    };
    const esqueleto = () => {
        const d = el('div', S.olhoEsq);
        for (let k = 0; k < 5; k++) {
            const lin = el('div', S.olhoEsqLinha);
            const txt = el('span', S.olhoEsqTxt);
            const a = el('i'); a.setAttribute('data-w', 'l1');
            const b = el('i'); b.setAttribute('data-w', 'l2');
            txt.append(a, b);
            lin.append(el('span', S.olhoEsqIco), txt);
            d.appendChild(lin);
        }
        d.appendChild(el('span', 'sr-only', t('olho_carregando')));
        const [h, c] = casca(d);
        const rot = el('div', S.olhoEsq);
        const r1 = el('i'); r1.setAttribute('data-w', 'rot');
        const r2 = el('i'); r2.setAttribute('data-w', 'tit');
        rot.append(r1, r2);
        h.insertBefore(rot, h.firstChild);
        h.querySelector('.' + S.olhoTit).classList.add('sr-only');
        h.querySelector('.' + S.olhoTit).textContent = t('olho_carregando');
        return [h, c];
    };
    const falha = (sessao) => {
        const d = el('div');
        const a = el('div'); a.setAttribute('role', 'alert');
        const p = el('p', S.olhoMsg, t(sessao ? 'olho_sessao' : 'olho_erro'));
        if (!sessao) p.setAttribute('data-tom', 'erro');
        a.appendChild(p); d.appendChild(a);
        if (!sessao) {
            const ac = el('div', S.olhoAcao);
            const b = el('button', S.olhoTentar, t('olho_tentar')); b.type = 'button';
            ac.appendChild(b); d.appendChild(ac);
        }
        const [h, c] = casca(d);
        h.querySelector('.' + S.olhoTit).textContent = t('olho_erro');
        h.querySelector('.' + S.olhoTit).classList.add('sr-only');
        return [h, c];
    };

    // linha de baixo do cabeçalho alinhada à do .tk-head (§3.4, lab talkAlinhaOlho)
    const alinhar = () => {
        const h = olhoIn ? olhoIn.querySelector(':scope > .' + S.olhoHead) : null;
        const head = document.querySelector(S.head);
        if (!h) return;
        h.style.minHeight = ''; h.style.paddingTop = ''; h.style.paddingBottom = '';
        if (!head || regime() === 'unico') return;
        const d = B(head).bottom - B(h).top;
        const nat = B(h).height;
        if (d > nat + 0.5) { h.style.minHeight = d + 'px'; return; }
        if (nat > d + 0.5) {
            const cs = getComputedStyle(h);
            const pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
            const tira = (nat - d) / 2;
            h.style.paddingTop = Math.max(6, pt - tira) + 'px';
            h.style.paddingBottom = Math.max(6, pb - tira) + 'px';
        }
    };

    const pintar = (nos) => {
        if (st.rolagem) { st.rolagem.soltar(); st.rolagem = null; }
        if (typeof nos === 'string') olhoIn.innerHTML = nos; else olhoIn.replaceChildren(...nos);
        olhoIn.removeAttribute('aria-busy');
        const corpo = olhoIn.querySelector(':scope > .' + S.olhoCorpo);
        if (corpo) {
            st.rolagem = NavScroll.ligar(corpo, { observar: Array.from(corpo.children) });   // G-M9 (RolagemPropria)
            // pedido do dono (2026-10-25, painel que não rolava): o corpo é a região que rola; focável para o teclado (setas, PgDn, End),
            // nomeada pelo título do painel
            corpo.tabIndex = 0; corpo.setAttribute('role', 'region'); corpo.setAttribute('aria-labelledby', S.olhoTitId);
        }
        olho.dataset.tipo = st.tipo || '';
        numerosNoCelular();
        ligarConteudo();
        alinhar();
    };
    // Celular (painel único, tickets/_mobile.scss): os mostradores saem do topo do ticket e aparecem aqui, no alto da página do cliente
    // (lab .m-cli-nums). Cópia estática, sem ids nem carga própria: os originais continuam sendo os alvos do openOrderData/openClientTickets.
    const numerosNoCelular = () => {
        const corpo = olhoIn.querySelector(':scope > .' + S.olhoCorpo);
        const nums = document.querySelector(S.nums);
        if (!corpo || !nums || st.tipo !== 'cliente' || regime() !== 'unico') return;
        const c = nums.cloneNode(true);
        c.classList.add('tk-olho-nums');
        c.querySelectorAll('[id], .execute-ajax-on-load').forEach((n) => { n.removeAttribute('id'); n.classList.remove('execute-ajax-on-load'); });
        corpo.insertBefore(c, corpo.firstChild);
    };

    const urlDe = (g) => {
        const base = g.dataset.url || '';
        if (!base || st.tipo === 'cliente') return base;
        const u = new URL(base, location.href);
        const head = document.querySelector(S.headUser);
        if (head) u.searchParams.set('user_id', head.dataset.user);
        const f = document.querySelector(S.aberto);
        if (st.tipo === 'ticket' && f) u.searchParams.set('aberto', f.dataset.ticket);
        return u.toString();
    };

    // F-1 do parecer-d35-bloco-h (LICOES 122): a recarga do Pusher é em 2º plano e o atendente pode começar a escrever ENQUANTO ela voa.
    // "Ocupado" = texto/anexo não enviado no painel OU foco num controle do painel (fora o título). Conferido no disparo, no 1º toque de
    // teclado (aborta a recarga em voo) e de novo na CHEGADA da resposta: ocupado → não redesenha; mostra a faixa "Este ticket mudou".
    const ocupado = () => !!motivoPainel() || (olho.contains(document.activeElement) && document.activeElement !== document.getElementById(S.olhoTitId));
    const faixaMudou = () => {
        const corpo = olhoIn.querySelector('.' + S.olhoCorpo);
        if (!corpo || corpo.querySelector('.' + S.olhoMudou)) return;
        const f = el('div', S.olhoMudou); f.setAttribute('role', 'status');
        const b = el('button', null, t('olho_atualizar')); b.type = 'button'; b.dataset.olhoAtualizar = '1';
        f.append(el('span', null, t('olho_mudou')), b);
        corpo.insertBefore(f, corpo.firstChild);
    };
    const carregar = (silencioso) => {
        if (!st.url) { pintar(falha(false)); return Promise.resolve(); }
        if (st.ctrl) st.ctrl.abort();
        const seq = ++st.seq;
        const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        st.ctrl = ctrl;
        const relogio = ctrl ? setTimeout(() => ctrl.abort(), TEMPO_MS) : null;
        if (!silencioso) { pintar(esqueleto()); olhoIn.setAttribute('aria-busy', 'true'); }
        const scroll0 = silencioso ? ((olhoIn.querySelector('.' + S.olhoCorpo) || {}).scrollTop || 0) : 0;
        st.silenciosa = silencioso ? seq : 0;
        return fetch(st.url, { method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, signal: ctrl ? ctrl.signal : undefined })
            .then((r) => {
                if (r.status === 419 || r.redirected) return { sessao: true };
                if (!r.ok) return { erro: true };
                if ((r.headers.get('content-type') || '').indexOf('json') < 0) return { sessao: true };
                return r.json().then((j) => {
                    const res = j && typeof j === 'object' && !j.error ? j.result : null;
                    return res && typeof res.html === 'string' && res.html.trim() !== '' ? { html: res.html } : { erro: true };
                });
            })
            .catch(() => ({ erro: true }))
            .then((o) => {
                if (relogio) clearTimeout(relogio);
                if (seq !== st.seq || !aberto()) return;   // outro gatilho, fechado, ou um "Tentar de novo" mais novo
                if (st.silenciosa === seq) st.silenciosa = 0;
                if (silencioso && (!o.html || ocupado())) { if (o.html) faixaMudou(); return; }   // F-1: nunca redesenha por cima do que se escreve
                const focoNoTit = document.activeElement && document.activeElement.id === S.olhoTitId;
                if (o.html) pintar(o.html); else pintar(falha(!!o.sessao));
                if (silencioso) { const c = olhoIn.querySelector('.' + S.olhoCorpo); if (c) c.scrollTop = scroll0; }
                if (focoNoTit || (!silencioso && olho.contains(document.activeElement) === false && st.fase !== 'fechando' && st.focarAoCarregar)) {
                    const tit = document.getElementById(S.olhoTitId); if (tit) tit.focus({ preventScroll: true });
                }
                st.focarAoCarregar = false;
            });
    };

    // ---------- dentro do painel: Tipo, nota, e-mail, Documentos, Tentar de novo (§3.2) ----------
    const escapar = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])).replace(/\r?\n/g, '<br>');
    const ligarConteudo = () => {
        olhoIn.querySelectorAll(S.olhoForm).forEach((form) => {
            const ta = form.querySelector(S.olhoTexto);
            const btn = form.querySelector('button[type="submit"]');
            // LICOES 123: enquanto o envio está no ar, o botão fica desligado mesmo que se digite (o submitAjax só o religa no fim)
            const sinc = () => { if (btn) btn.disabled = !ta || ta.value.trim() === '' || form.dataset.enviando === '1'; };
            if (ta) ta.addEventListener('input', sinc);
            sinc();
            // no próprio form: roda ANTES do submitAjax delegado no document (o hidden já vai preenchido no serialize/FormData)
            form.addEventListener('submit', (e) => {
                const campo = form.querySelector('input[type="hidden"][name="' + form.dataset.tkOlhoEscapar + '"]');
                if (!ta || ta.value.trim() === '' || !campo || form.dataset.enviando === '1') { e.preventDefault(); e.stopImmediatePropagation(); return; }
                campo.value = escapar(ta.value.trim());
                form.dataset.enviando = '1';
            });
            const arq = form.querySelector('input[type="file"]');
            const nome = form.querySelector(S.olhoAnexoNome);
            if (arq && nome) arq.addEventListener('change', () => { nome.textContent = arq.files && arq.files[0] ? arq.files[0].name : ''; });
        });
        olhoIn.querySelectorAll(S.olhoDocs).forEach((d) => {
            d.addEventListener('toggle', () => {
                const alvo = d.querySelector('[data-url]');
                if (!d.open || !alvo || alvo.dataset.carregado) return;
                alvo.dataset.carregado = '1';
                fetch(alvo.dataset.url, { method: 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
                    .then(r => (r.ok ? r.json() : null)).catch(() => null)
                    .then((j) => {
                        if (j && !j.error && j.result && typeof j.result.html === 'string') { alvo.innerHTML = j.result.html; return; }
                        alvo.replaceChildren(el('p', S.olhoMsg, 'Falha ao carregar'));
                        delete alvo.dataset.carregado;
                    });
            });
        });
    };

    // ---------- inert (§2.7) ----------
    const prender = () => {
        st.inertes = [];
        [fila, document.querySelector(S.detalhe), document.querySelector('.sidebar'), document.querySelector('.topbar')].forEach((n) => {
            if (n && !n.inert) { n.inert = true; st.inertes.push(n); }
        });
    };
    const soltarInertes = () => { st.inertes.forEach(n => { n.inert = false; }); st.inertes = []; };
    const papel = () => {
        if (st.tipo === 'cliente') { olho.setAttribute('role', 'dialog'); olho.setAttribute('aria-modal', 'true'); }
        else { olho.setAttribute('role', 'complementary'); olho.removeAttribute('aria-modal'); }
    };
    // Película do cliente (pedido do dono, 2026-10-25; lab: escurece TUDO menos o painel, inclusive o menu e o topo inteiro, também acima do
    // painel). Duas peças no <body> (o init tira a do blade da .tk-tela e cria a do topo), fixas e acima do shell, que NÃO se sobrepõem ao
    // painel: a do topo cobre a janela inteira acima do painel (0..T); a outra, abaixo dela, tudo à esquerda do painel (0..L). Retângulo
    // FINAL do painel: a .row da .tk-tela (abaixo de 720 a .row inteira; senão a faixa direita de largura Lo, §4). Sem clip-path: com um
    // recorte por cima, o Chrome mandava a roda do mouse para a película e o corpo do painel não rolava (medido na probe).
    const posVeu = () => {
        if (!veu || st.tipo !== 'cliente') return;
        const rr = B(tela.querySelector(S.linhaGrade) || tela);
        const L = regime() === 'unico' ? rr.left : rr.right - larguraPainel();
        const W = document.documentElement.clientWidth;
        veu.style.top = rr.top + 'px'; veu.style.right = Math.max(0, W - L) + 'px';
        if (veuTopo) { veuTopo.style.bottom = 'auto'; veuTopo.style.height = Math.max(0, rr.top) + 'px'; }
    };
    const veuLiga = () => {
        if (!veu) return;
        [veu, veuTopo].forEach((v) => { if (!v) return; if (st.tipo === 'cliente') v.setAttribute('data-aceso', ''); else v.removeAttribute('data-aceso'); });   // a forma fica: o fade de saída a mantém
        if (st.tipo === 'cliente') posVeu();
    };

    // ---------- movimento (§2.4) ----------
    const filhosFila = () => Array.from(fila.children).filter(c => c !== trilho);
    const limparInline = () => {
        fila.style.flexBasis = ''; olho.style.flexBasis = '';
        const c = ctxEl(); if (c) c.style.flexBasis = '';
        fila.style.transition = ''; olho.style.transition = '';
        filhosFila().forEach(c2 => { c2.style.width = ''; });
        olhoIn.style.width = '';
    };
    // FAIL-H2 do QA (06-qa/d35-final-v4): o fim de um movimento é de UM movimento só. Cada aoFim tem o seu token (o próprio objeto em
    // st.fim); o ouvinte/teto de um movimento cancelado (fechar no meio e reabrir, ou o contrário) é removido e, se ainda disparar, não age.
    const cancelarFim = () => {
        const f = st.fim;
        if (!f) return;
        clearTimeout(f.teto); olho.removeEventListener('transitionend', f.h); fila.removeEventListener('transitionend', f.h);
        st.fim = null;
    };
    const aoFim = (fn, ms) => {
        cancelarFim();
        const animando = olho.getAnimations().length > 0 || fila.getAnimations().length > 0;
        if (!animando) { fn(); return; }
        const meu = {};
        const terminar = () => {
            if (st.fim !== meu) return;   // movimento substituído: nada a fazer
            cancelarFim();
            fn();
        };
        meu.h = (e) => {
            if (e.target !== olho && e.target !== fila) return;
            if (e.propertyName !== 'flex-basis' && e.propertyName !== 'transform') return;
            if (olho.getAnimations().length || fila.getAnimations().length) return;
            terminar();
        };
        meu.teto = setTimeout(terminar, ms + FOLGA_MS);
        st.fim = meu;
        olho.addEventListener('transitionend', meu.h);
        fila.addEventListener('transitionend', meu.h);
    };

    const abrirMovimento = () => {
        const r = regime();
        const Lo = larguraPainel();
        if (r !== 'unico') {
            // FAIL-H4 do QA (LICOES 125): reabrir no meio do fechamento achava a fila e o painel AINDA andando (a transição do painel não
            // depende da fase) e congelava o contexto na largura daquele instante (320/381 a 1920). O Lc é o do estado FECHADO em repouso:
            // sem transição, fila e painel na régua de fechado, mede; depois volta ao ponto onde o movimento anterior os deixou e anima
            // dali (mesmo quadro: nada é pintado no meio).
            const Lf0 = B(fila).width, Lo0 = B(olho).width;
            const c = r === '3col' ? ctxEl() : null;
            fila.style.transition = 'none'; olho.style.transition = 'none';
            fila.style.flexBasis = ''; olho.style.flexBasis = '0px';
            if (c) { c.style.flexBasis = ''; c.style.flexBasis = B(c).width + 'px'; }
            const LfFechada = B(fila).width;
            fila.style.flexBasis = Lf0 + 'px';
            olho.style.flexBasis = Lo0 + 'px';
            filhosFila().forEach(f => { f.style.width = LfFechada + 'px'; });
            olhoIn.style.width = Lo + 'px';
            void fila.offsetWidth;
            fila.style.transition = ''; olho.style.transition = '';
            tela.setAttribute('data-olho', st.tipo);
            tela.setAttribute('data-olho-fase', 'abrindo');
            fila.style.flexBasis = '64px';
            olho.style.flexBasis = Lo + 'px';
        } else {
            tela.setAttribute('data-olho', st.tipo);
            tela.setAttribute('data-olho-fase', 'abrindo');
        }
        veuLiga();
        st.fase = 'abrindo';
        aoFim(() => { if (st.fase === 'abrindo') { st.fase = 'aberto'; tela.setAttribute('data-olho-fase', 'aberto'); } }, r === 'unico' ? UNICO_MS : MOV_MS);
    };

    const fecharMovimento = (depois) => {
        const r = regime();
        st.fase = 'fechando';
        tela.setAttribute('data-olho-fase', 'fechando');
        tela.removeAttribute('data-olho');   // fila, trilho e película voltam/saem (opacidade); o painel fica visível até o fim (visibility atrasada)
        veuLiga();
        if (r !== 'unico') {
            const LfF = larguraFila();
            filhosFila().forEach(f => { f.style.width = LfF + 'px'; });
            fila.style.flexBasis = LfF + 'px';
            olho.style.flexBasis = '0px';
        }
        aoFim(() => {
            limparInline();
            tela.removeAttribute('data-olho-fase');
            olhoIn.replaceChildren();
            if (st.rolagem) { st.rolagem.soltar(); st.rolagem = null; }
            olho.removeAttribute('data-tipo');
            st.fase = null;
            if (depois) depois();
        }, r === 'unico' ? UNICO_MS : MOV_MS);
    };

    // ---------- abrir / trocar / fechar (§2.3) ----------
    // FAIL-H1 do QA: trocar de conteúdo (outro gatilho com o painel aberto) com rascunho no painel passa pela MESMA guarda de descarte do × e
    // do mesmo gatilho. "Continuar" mantém o painel e o rascunho; "descartar" limpa e troca.
    const abrir = (g) => {
        const tipo = g.dataset.olho;
        if (!tipo || !olho) return;
        if (aberto() && mesmo(g)) { fechar('gatilho'); return; }
        const m = (aberto() && st.fase !== 'fechando') ? motivoPainel() : null;
        if (m) {
            if (!SaidaDetalhe.perguntarDescarte) return;
            SaidaDetalhe.perguntarDescarte(m, olhoIn.querySelector(S.olhoTexto)).then((ok) => {
                if (!ok || !g.isConnected) return;
                olhoIn.querySelectorAll(S.olhoTexto).forEach(t => { t.value = ''; });
                olhoIn.querySelectorAll('input[type="file"]').forEach(f => { f.value = ''; });
                abrir(g);
            });
            return;
        }
        const trocando = aberto() && st.fase !== 'fechando';
        if (st.fase === 'fechando') {   // reabrir no meio do fechamento: o fim do fechamento é cancelado (FAIL-H2) e o conteúdo velho sai
            cancelarFim(); limparInline(); tela.removeAttribute('data-olho-fase'); st.fase = null;
            olhoIn.replaceChildren(); if (st.rolagem) { st.rolagem.soltar(); st.rolagem = null; }
        }
        if (!trocando && regime() === 'gaveta') {   // §4: a gaveta do contexto fecha antes (as duas cobrem a direita)
            const corpo = document.querySelector(S.corpo + '[data-ctx="aberto"]');
            if (corpo) { if (window.tkPaineis && window.tkPaineis.fecharGaveta) window.tkPaineis.fecharGaveta(); else corpo.removeAttribute('data-ctx'); }
        }
        if (trocando && st.tipo === 'cliente' && tipo !== 'cliente') soltarInertes();
        st.tipo = tipo; st.id = g.dataset.id || ''; st.gatilho = g; st.url = urlDe(g);
        st.cliTxt = null;
        if (tipo === 'cliente') { try { st.cliTxt = JSON.parse(g.dataset.textos || '{}') || null; } catch (e) { st.cliTxt = null; } }
        papel();
        olho.inert = false;
        if (regime() !== 'unico') trilho.inert = false;
        realcar(true);
        posVeu();
        if (tipo === 'cliente' && !st.inertes.length) prender();
        st.focarAoCarregar = true;
        if (!trocando) {
            refazerTrilho();
            abrirMovimento();
        } else {
            tela.setAttribute('data-olho', tipo);   // troca: nada se move (T-H6); a película entra/sai pelo tipo
            veuLiga();
        }
        carregar(false);
        requestAnimationFrame(() => { const tit = document.getElementById(S.olhoTitId); if (tit && aberto()) tit.focus({ preventScroll: true }); });
    };

    const motivoPainel = () => {
        if (!olhoIn) return null;
        const texto = Array.from(olhoIn.querySelectorAll(S.olhoTexto)).some(e => String(e.value || '').trim() !== '');
        const anexo = Array.from(olhoIn.querySelectorAll(S.olhoPe)).some(e => e.files && e.files.length > 0);
        return texto && anexo ? 'descartar_ambos' : (texto ? 'descartar_texto' : (anexo ? 'descartar_anexo' : null));
    };

    // FAIL-H3 do QA: o foco volta ao gatilho se ele está VISÍVEL e aceita o foco; senão, ao 1º alvo definido e visível: a barra do ticket
    // (.tk-faixa, tabindex -1), o "i", o card aberto, a busca. Conferido pelo document.activeElement (a 360 o olho da linha do tempo fica
    // na gaveta fechada e o foco caía no BODY).
    const visivel = (e) => !!e && e.isConnected && e.getClientRects().length > 0 && getComputedStyle(e).visibility !== 'hidden' && !e.closest('[inert]');
    const focarVolta = (g) => {
        const cands = [g, document.querySelector(S.aberto), document.querySelector(S.detalhe + ' ' + S.gatilho),
            document.querySelector(S.lista + ' ' + S.item + '[aria-current="true"] ' + S.abrir), document.querySelector(S.buscaCampo)];
        for (const c of cands) {
            if (!visivel(c)) continue;
            c.focus({ preventScroll: true });
            if (document.activeElement === c) return c;
        }
        return null;
    };

    // origem: 'x' | 'trilho' | 'veu' | 'gatilho' | 'esc' | 'detalhe' (forçado: o detalhe já trocou)
    const fechar = (origem) => {
        if (!aberto()) return Promise.resolve(true);
        const m = origem === 'detalhe' ? null : motivoPainel();
        const pergunta = m && SaidaDetalhe.perguntarDescarte ? SaidaDetalhe.perguntarDescarte(m, olhoIn.querySelector(S.olhoTexto)) : Promise.resolve(true);
        return pergunta.then((ok) => {
            if (!ok || !aberto()) return false;
            const g = st.gatilho;
            // o que estava escrito foi descartado (confirmado, ou o detalhe já trocou depois da guarda D17b): some JÁ, e não no fim do
            // movimento — senão o beforeunload ainda veria "trabalho" por ~1 s no conteúdo que só sai depois de 884 ms
            olhoIn.querySelectorAll(S.olhoTexto).forEach(t => { t.value = ''; });
            olhoIn.querySelectorAll('input[type="file"]').forEach(f => { f.value = ''; });
            if (st.ctrl) st.ctrl.abort();
            st.seq++;
            clearTimeout(st.lote); st.lote = null;
            soltarInertes();
            realcar(false);
            st.tipo = null; st.id = null; st.gatilho = null; st.url = '';
            olho.inert = true; trilho.inert = true;
            olho.removeAttribute('aria-modal');
            fecharMovimento(null);
            // foco: o gatilho, se ainda está no DOM; senão a faixa; senão o card aberto (§2.7)
            if (origem !== 'detalhe') focarVolta(g);
            return true;
        });
    };

    // ---------- foco preso no cliente (§2.7): o resto já é inert; o Tab circula dentro do painel em vez de sair para o navegador ----------
    const FOCAVEIS = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const aoTab = (e) => {
        if (e.key !== 'Tab' || st.tipo !== 'cliente' || !olho.contains(document.activeElement)) return;
        const fs = Array.from(olho.querySelectorAll(FOCAVEIS)).filter(x => x.offsetParent !== null || x === document.activeElement);
        if (!fs.length) return;
        const pri = fs[0], ult = fs[fs.length - 1], at = document.activeElement;
        if (e.shiftKey && (at === pri || at.id === S.olhoTitId)) { e.preventDefault(); ult.focus(); }
        else if (!e.shiftKey && at === ult) { e.preventDefault(); pri.focus(); }
    };

    // ---------- Pusher (§5.4) ----------
    const aoEvento = (e) => {
        const id = e && e.detail ? String(e.detail.ticket_id || '') : '';
        if (!id || st.tipo !== 'ticket' || String(st.id) !== id) return;
        clearTimeout(st.lote);
        st.lote = setTimeout(() => {
            st.lote = null;
            if (st.tipo !== 'ticket' || String(st.id) !== id) return;
            if (ocupado()) { faixaMudou(); return; }
            carregar(true);
        }, LOTE_MS);
    };

    // ---------- cliques ----------
    const aoClicar = (e) => {
        const alvo = e.target instanceof Element ? e.target : null;
        if (!alvo || !tela) return;
        if (veu && (alvo === veu || alvo === veuTopo)) { fechar('veu'); return; }   // a película mora no <body>, fora da .tk-tela
        if (!tela.contains(alvo)) return;
        const g = alvo.closest('[data-olho]');
        if (g && tela.contains(g) && g.dataset.url !== undefined && g !== olho) {
            if (g.tagName === 'A' && (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)) return;   // H-G3: meio/Ctrl = aba nova
            if (!g.dataset.url && g.tagName === 'A') return;   // sem a rota do painel: o link de sempre
            e.preventDefault();
            abrir(g);
            return;
        }
        if (alvo.closest('#' + S.olhoId + ' .' + S.olhoX)) { fechar('x'); return; }
        if (alvo.closest(S.trilhoAbrir)) { fechar('trilho'); return; }
        const ini = alvo.closest(S.trilhoItem);
        if (ini) {   // passa pela guarda D17b (sem clicarLiberado); a troca do detalhe fecha o painel
            const b = document.querySelector('#opportunity_' + ini.dataset.ticket + ' ' + S.abrir);
            if (b) b.click();
            return;
        }
        if (alvo.closest('#' + S.olhoId + ' .' + S.olhoTentar + ', #' + S.olhoId + ' ' + S.cliTentar + ', #' + S.olhoId + ' [data-olho-atualizar]')) {
            if (alvo.closest('[data-olho-atualizar]') && motivoPainel()) {
                SaidaDetalhe.perguntarDescarte(motivoPainel(), null).then((ok) => { if (ok) carregar(false); });
                return;
            }
            carregar(false);
        }
    };
    // o meio do mouse não gera click em <a>: só auxclick, que segue o href (aba nova) sem passar por aqui

    // F-2 do parecer-d35-bloco-h: o sucesso legado (appendElementInModal) só limpa a .textarea-modal-ticket; o e-mail do painel ficava cheio
    // (guarda falsa, reenvio fácil, Pusher parado). Aqui, no fim de QUALQUER envio de um form do painel: solta o "enviando"; no sucesso,
    // limpa o texto, o anexo e o nome do anexo e desliga o botão (o submitAjax já o religou no success, que roda antes do evento global).
    const aoFimEnvio = (ev, xhr, settings) => {
        if (!olhoIn) return;
        olhoIn.querySelectorAll(S.olhoForm).forEach((form) => {
            if (settings.url !== form.dataset.action || form.dataset.enviando !== '1') return;
            delete form.dataset.enviando;
            let d = null; try { d = xhr.responseJSON || JSON.parse(xhr.responseText || 'null'); } catch (e) { d = null; }
            const ok = xhr.status === 200 && d && d.error === false;
            const ta = form.querySelector(S.olhoTexto);
            if (ok) {
                if (ta) ta.value = '';
                const arq = form.querySelector('input[type="file"]'); if (arq) arq.value = '';
                const nome = form.querySelector(S.olhoAnexoNome); if (nome) nome.textContent = '';
            }
            if (ta) ta.dispatchEvent(new Event('input'));   // sinc: sem texto, botão desligado
        });
    };

    // ---------- Tipo do painel = ticket aberto: sincroniza o oculto da barra (H-T3, LICOES 64) ----------
    const aoAjax = (ev, xhr, settings, data) => {
        if (!aberto() || st.tipo !== 'ticket') return;
        const sel = olhoIn.querySelector(S.olhoSel);
        if (!sel || settings.url !== sel.dataset.urlajax || !data || data.error) return;
        const op = sel.options[sel.selectedIndex];
        const tipo = { id: parseInt(sel.value, 10), nome: op ? op.textContent.trim() : '' };
        if (window.tkFaixa && typeof window.tkFaixa.tipo === 'function') window.tkFaixa.tipo(parseInt(st.id, 10), tipo);
    };

    // a linha do tempo é refeita por AJAX: o realce volta no nó novo (§2.8), 1 varredura por quadro
    let quadro = 0;
    const vigiarRealce = (raiz) => {
        new MutationObserver(() => { if (!quadro && aberto()) quadro = requestAnimationFrame(() => { quadro = 0; realcar(true); }); }).observe(raiz, { childList: true, subtree: true });
    };

    return {
        init: function (opts) {
            const s = Object.assign({}, PADRAO, opts || {});   // DD-04: S só muda quando a guarda liga
            if (tela) return;   // já ligado nesta página (2º init com o mapa de outra tela)
            tela = document.querySelector(s.tela);
            olho = document.getElementById(s.olhoId);
            if (!tela || !olho) { tela = null; olho = null; return; }   // só na tela de tickets nova (ou na do mapa)
            S = s;
            fila = document.getElementById(S.filaId);
            olhoIn = olho.querySelector(S.olhoIn);
            trilho = document.getElementById(S.trilhoId);
            trilhoLista = trilho ? trilho.querySelector(S.trilhoLista) : null;
            veu = tela.querySelector(S.veu);
            if (veu) {   // fixa e acima do menu e do topo: fora da .tk-tela (sticky, z-index 2 = contexto próprio)
                document.body.appendChild(veu);
                veuTopo = veu.cloneNode(false); veuTopo.classList.add(S.veuTopo);
                document.body.appendChild(veuTopo);
            }
            try { T = JSON.parse((fila && fila.dataset.textos) || '{}') || {}; } catch (e) { T = {}; }
            document.addEventListener('click', aoClicar);
            document.addEventListener('tk:ticket-evento', aoEvento);
            document.addEventListener('keydown', aoTab);
            if (window.jQuery) { window.jQuery(document).ajaxSuccess(aoAjax); window.jQuery(document).ajaxComplete(aoFimEnvio); }
            // F-1: o 1º toque de teclado / input no painel aborta a recarga silenciosa em voo (a faixa "mudou" fica no lugar dela)
            const tocar = () => { if (st.silenciosa && st.ctrl) { st.ctrl.abort(); st.silenciosa = 0; st.seq++; faixaMudou(); } };
            olho.addEventListener('keydown', tocar, true);
            olho.addEventListener('input', tocar, true);
            const det = document.querySelector(S.detalhe);
            if (det) {
                // o detalhe foi trocado (abrir outro, Próximo, fechar o ticket, Assumir, Abrir de novo): o painel era daquele cliente
                new MutationObserver(() => { if (aberto()) fechar('detalhe'); else if (!st.fase) realcar(false); }).observe(det, { childList: true });
                vigiarRealce(det);
            }
            if (window.tkFila && typeof window.tkFila.aoMudar === 'function') window.tkFila.aoMudar(() => { if (aberto()) refazerTrilho(); });
            if (window.ResizeObserver) {
                new ResizeObserver(() => {
                    if (!aberto() || st.fase !== 'aberto') return;
                    const r = regime(), Lo = larguraPainel();
                    olhoIn.style.width = r === 'unico' ? '' : Lo + 'px';
                    if (r !== 'unico') { olho.style.flexBasis = Lo + 'px'; fila.style.flexBasis = '64px'; } else limparInline();
                    posVeu();
                    alinhar();
                }).observe(tela);
            }
            window.tkOlho = { aberto: aberto, fechar: fechar, estado: () => ({ tipo: st.tipo, id: st.id, fase: st.fase }) };
        },
    };
}();

module.exports = PainelOlho;
